import { withInstall } from '@xzx-design/utils'
import _Checkbox from './src/checkbox.tsx'
import _CheckboxGroup from './src/checkbox-group.tsx'

export const Checkbox = withInstall(_Checkbox)
export const CheckboxGroup = withInstall(_CheckboxGroup)
export default Checkbox

export * from './src/checkbox'
export * from './src/types'
